/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleInfoModel {
    getFixupPrototypeFunction() { return RoleInfoModel.fixupPrototype; }

    static newInstance(model: Partial<RoleInfoModel>): RoleInfoModel {
        let obj = Object.assign(new RoleInfoModel(), model);
        RoleInfoModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleInfoModel>): RoleInfoModel {
        if (!model) return null;
        return RoleInfoModel.newInstance(<RoleInfoModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleInfoModel) {
        if (!obj) return;

        models.RoleInfoModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleInfoModel): boolean {
        Object.setPrototypeOf(obj, RoleInfoModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant id
     */
    tenant_id: string;

    /**
     * list of role ids assigned to user
     */
    roles: Array<string>;

}
